<template>
  <TableLayout v-permissions="['customer:query']">
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
      <el-form-item label="市场" prop="realname">
        <el-input v-model="searchForm.realname" placeholder="请输入负责人姓名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="mobile">
        <el-input v-model="searchForm.mobile" placeholder="请输入联系方式" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="登录用户名" prop="account">
        <el-input v-model="searchForm.account" placeholder="请输入登录用户名" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['customer:create', 'customer:delete']">
        <li><el-button type="primary" @click="$refs.operaCustomerWindow.open('新建市场')" icon="el-icon-plus" v-permissions="['customer:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['customer:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        :default-sort="{prop: 'createTime', order: 'descending'}"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="realname" label="市场" min-width="100px"></el-table-column>
        <el-table-column prop="mobile" label="手机号" min-width="100px">
          <template slot-scope="{ row }">{{ row.mobile | mobileText }}</template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="100px"></el-table-column>
        <el-table-column prop="gender" label="性别" min-width="100px">
          <template slot-scope="{row}">{{row.gender | sex}}</template>
        </el-table-column>
        <el-table-column prop="account" label="登录用户名" min-width="100px"></el-table-column>
        <el-table-column prop="lastLoginTime" sortable="custom" sort-by="customer.LAST_LOGIN_TIME" label="最后登录时间" min-width="140px"></el-table-column>
        <el-table-column prop="lastOrderTime" sortable="custom" sort-by="customer.LAST_ORDER_TIME" label="最后下单时间" min-width="140px"></el-table-column>
        <el-table-column prop="createUserInfo.realname" label="分配人" min-width="120px"></el-table-column>
        <el-table-column prop="createTime" sortable="custom" sort-by="customer.CREATE_TIME" label="账号分配时间" min-width="140px"></el-table-column>
        <el-table-column prop="updateUserInfo.realname" label="更新人" min-width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="140px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['customer:update', 'customer:delete', 'customer:password:reset'])"
          label="操作"
          min-width="200"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.resetWindow.open(row)" v-permissions="['customer:password:reset']">重置密码</el-button>
            <el-button type="text" @click="$refs.operaCustomerWindow.open('编辑市场', row)" icon="el-icon-edit" v-permissions="['customer:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['customer:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaCustomerWindow ref="operaCustomerWindow" @success="handlePageChange"/>
    <!-- 重置密码 -->
    <ResetWindow ref="resetWindow"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import OperaCustomerWindow from '@/components/customer/OperaCustomerWindow.vue'
import ResetWindow from '@/components/customer/ResetWindow'
export default {
  name: 'CustomerList',
  extends: BaseTable,
  components: { ResetWindow, TableLayout, Pagination, OperaCustomerWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        company: '',
        realname: '',
        mobile: '',
        account: ''
      }
    }
  },
  created () {
    this.config({
      module: '市场',
      api: '/customer/customer',
      'field.id': 'id',
      'field.main': 'company',
      sorts: [{
        property: 'customer.CREATE_TIME',
        direction: 'DESC'
      }]
    })
    this.search()
  }
}
</script>
